import { NSCard } from 'bricks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { CardBody } from 'reactstrap';
import { URLS } from 'services/urls';
import { ensureUrlProtocol } from 'helpers/url';
import { ICompany } from '../types';

export const formatCompanyUrl = (url: string): string => {
    try {
        const { hostname } = new URL(url);
        return hostname.replace(/^www\./, '');
    } catch {
        return url;
    }
};

const CompanyCard = ({ name, companyUrl, id }: ICompany) => {
    const handleCardClick = () => {
        window.location.href = URLS.PROJECTS_APP.COMPANY_DETAILS(id);
    };

    return (
        <NSCard
            className="NSCard--level-3 p-2 my-2 cursor--pointer"
            onClick={handleCardClick}
        >
            <CardBody className="d-flex justify-content-between align-items-center p-0">
                <div>
                    <span className="text-dark d-block">{name}</span>
                    {!!companyUrl && (
                        <a
                            href={ensureUrlProtocol(companyUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()}
                        >
                            <div className="d-flex align-items-center">
                                <small className="text-muted">{formatCompanyUrl(companyUrl)}</small>
                                <FontAwesomeIcon
                                    className="text-primary ml-1"
                                    icon={faArrowUpRightFromSquare}
                                    size="sm"
                                />
                            </div>
                        </a>
                    )}
                </div>
            </CardBody>
        </NSCard>
    );
};
export default CompanyCard;
